import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import {
  LoadScript,
  GoogleMap,
  Marker,
  Autocomplete,
} from "@react-google-maps/api";
import Logo from "../assets/logo.png";
import PhoneInput from "react-phone-input-2";
import { CheckCircle, PinDrop } from "@mui/icons-material";
import { useGeolocated } from "react-geolocated";
import Camra from "../assets/camra.png";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
const googleMapsApiKey = "AIzaSyAOFJnj9gYTIPNZ3e57zsVi74X5t4j73CY";

const VerifyEmail = () => {
  const { coords } = useGeolocated({
    positionOptions: {
      enableHighAccuracy: true,
    },
    userDecisionTimeout: 5000,
  });
  const { user_uuid, user_code } = useParams();
  const [userData, setUserData] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [notification, setNotification] = useState("");
  const [mapDialogOpen, setMapDialogOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState({
    lat: null,
    lng: null,
  });
  const [autocomplete, setAutocomplete] = useState(null);
  const mapRef = useRef(null);

  const onLoad = (autocompleteInstance) => {
    setAutocomplete(autocompleteInstance);
  };

  const onPlaceChanged = async () => {
    if (autocomplete) {
      const place = autocomplete.getPlace();
      if (place.geometry) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        setSelectedLocation({ lat, lng });
        // Center the map on the selected place
        try {
          const result = await geocodeLatLng(lat, lng);
          console.log(result);

          const addressComponents = result.address_components;
          let city = "";
          let state = "";
          let zip = "";
          let country = "";
          let address = result.formatted_address || "";

          // Extract city, state, zip, and country from the address components
          console.log(addressComponents);
          for (let component of addressComponents) {
            const types = component.types;

            if (types.includes("locality")) {
              city = component.long_name;
            }
            if (types.includes("administrative_area_level_1")) {
              state = component.long_name;
            }
            if (types.includes("postal_code")) {
              zip = component.long_name;
            }
            if (types.includes("country")) {
              country = component.long_name;
            }
          }

          // If zip code is not found, set it to an empty string
          if (!zip) {
            zip = "N/A"; // Or handle this case based on your needs (e.g., leave it as "")
          }

          // Update userData with the real address data
          setUserData((prev) => ({
            ...prev,
            address,
            city,
            state,
            zip_code: zip,
            country,
            lat,
            lng,
          }));

          setMapDialogOpen(false); // Close the dialog after selecting
        } catch (error) {
          console.error(error);
          // setError("Failed to fetch address data. Please try again.");
        }
      }
    }
  };
  const geocodeLatLng = (lat, lng) => {
    const geocoder = new window.google.maps.Geocoder();

    return new Promise((resolve, reject) => {
      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status === "OK") {
          if (results[0]) {
            console.log("Geocoding result: ", results[0]); // Log the full result
            resolve(results[0]);
          } else {
            reject("No results found");
          }
        } else {
          reject("Geocoder failed due to: " + status);
        }
      });
    });
  };
  const handleMapClick = async (lat, lng) => {
    try {
      const result = await geocodeLatLng(lat, lng);
      console.log(result);

      const addressComponents = result.address_components;
      let city = "";
      let state = "";
      let zip = "";
      let country = "";
      let address = result.formatted_address || "";

      // Extract city, state, zip, and country from the address components
      console.log(addressComponents);
      for (let component of addressComponents) {
        const types = component.types;

        if (types.includes("locality")) {
          city = component.long_name;
        }
        if (types.includes("administrative_area_level_1")) {
          state = component.long_name;
        }
        if (types.includes("postal_code")) {
          zip = component.long_name;
        }
        if (types.includes("country")) {
          country = component.long_name;
        }
      }

      // If zip code is not found, set it to an empty string
      if (!zip) {
        zip = "N/A"; // Or handle this case based on your needs (e.g., leave it as "")
      }

      // Update userData with the real address data
      setUserData((prev) => ({
        ...prev,
        address,
        city,
        state,
        zip_code: zip,
        country,
        lat,
        lng,
      }));

      setMapDialogOpen(false); // Close the dialog after selecting
    } catch (error) {
      console.error(error);
      // setError("Failed to fetch address data. Please try again.");
    }
  };
  // const navigate = useNavigate();
  const verifyEmail = async (user_uuid, user_code) => {
    const response = await axios({
      method: "post",
      url: "/users/verifyUser",
      data: {
        user_uuid,
        email: user_code,
      },
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (response.data.success) {
      if (response.data.code === 1) {
        setNotification("User Verified Successfully");
        sessionStorage.setItem(
          "userData",
          JSON.stringify(response.data.result)
        );
        setUserData({ ...response.data.result });
        console.log({ coords });
      } else {
        window.location.href = "/success/Already Verified";
      }

      // navigate("/success/verifiedEmail");
    }
  };
  useEffect(() => {
    if (coords) {
      setUserData((prev) => ({
        ...prev,
        lat: coords.latitude,
        lng: coords.longitude,
      }));
      setSelectedLocation({
        lat: coords.latitude,
        lng: coords.longitude,
      });
      handleMapClick(coords.latitude, coords.longitude);
    }
  }, [coords]);
  const updateUser = async () => {
    if (!userData.first_name) {
      setError("First Name is required");
      return;
    } else if (!userData.last_name) {
      setError("Last Name is required");
      return;
    } else if (!userData.address) {
      setError("Address is required");
      return;
    } else if (!userData.city) {
      setError("City is required");
      return;
    } else if (!userData.state) {
      setError("State is required");
      return;
    } else if (!userData.zip_code) {
      setError("Zip Code is required");
      return;
    } else if (!userData.country) {
      setError("Country is required");
      return;
    }
    const url = "/users/UpdateUser";
    const formData = new FormData();
    formData.append("user_uuid", userData.user_uuid);
    formData.append("email", userData.email);
    formData.append("first_name", userData.first_name);
    formData.append("last_name", userData.last_name);
    formData.append("phone_number", userData.phone_number);
    formData.append("work_phone_number", userData.work_phone_number);
    formData.append("company_title", userData.company_title);
    formData.append("city", userData.city);
    formData.append("state", userData.state);
    formData.append("zip_code", userData.zip_code);
    formData.append("country", userData.country);
    formData.append("job_title", userData.job_title);
    formData.append("address", userData.address);
    formData.append("lat", userData.lat);
    formData.append("lng", userData.lng);
    formData.append("country_code", userData.country_code);
    formData.append("update_user_code", true);
    formData.append("gender", userData.gender);
    formData.append("age_range", userData.age_range);
    formData.append("marital_status", userData.marital_status);
    formData.append("annual_income_range", userData.annual_income_range);
    formData.append("employment_status", userData.employment_status);
    formData.append("education_attainment", userData.education_attainment);
    formData.append("dob", userData.dob);

    if (userData.profile) {
      formData.append("profile", userData.profile);
    }
    setLoading(true);
    try {
      const response = await axios({
        method: "post",
        url,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.data.success) {
        setNotification("User Updated Successfully");

        setUserData(response.data.result);
        setSelectedLocation({
          lat: +response.data.result.lat,
          lng: +response.data.result.lng,
        });
        handleMapClick(+response.data.result.lat, +response.data.result.lng);
        setTimeout(() => {
          window.location.href = "/success/updatedUser";
        }, 2000);
      }
    } catch (error) {
      setError("Failed to update user. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    verifyEmail(user_uuid, user_code);
  }, [user_uuid, user_code]);

  useEffect(() => {
    setTimeout(() => {
      setNotification("");
    }, 5000);
  }, [notification]);
  console.log({ userData });
  return (
    <>
      <Header />
      <div
        className="sign_up_page"
        style={{
          padding: "10px 0",
          maxWidth: "1200px",
        }}
      >
        {notification ? (
          <div className="success_dialogue">
            <div className="success_dialogue_icon">
              <CheckCircle />
            </div>
            <div className="success_dialogue_heading">{notification}</div>
          </div>
        ) : (
          ""
        )}

        {userData ? (
          <div
            className="sign_up_form_body"
            style={{
              maxWidth: "90vw",
            }}
          >
            <div className="sign_up_form_heading1">PROFILE INFORMATION</div>

            <div className="sign_up_form">
              <div className="row">
                <div className="input-wrapper">
                  <label
                    htmlFor="img_url"
                    className="flex"
                    style={{
                      justifyContent: "space-between",
                      alignItems: "center",
                      cursor: "pointer",
                      width: "200px",
                    }}
                  >
                    Profile :
                    <img
                      src={userData.img_url || Camra}
                      alt=""
                      style={{
                        width: "100px",
                        height: "100px",
                        borderRadius: "50%",
                        objectFit: "cover",
                        cursor: "pointer",
                        border: "1px solid #707070",
                      }}
                    />
                    <input
                      id="img_url"
                      style={{ display: "none" }}
                      type="file"
                      accept="image/*"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        const reader = new FileReader();
                        reader.onload = (e) => {
                          setUserData((prev) => ({
                            ...prev,
                            img_url: e.target.result,
                            profile: file,
                          }));
                        };
                        reader.readAsDataURL(file);
                      }}
                    />
                  </label>
                </div>
              </div>
              <div className="row">
                <div className="input-wrapper">
                  <label>
                    First Name<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="First Name"
                    value={userData.first_name}
                    onChange={(e) =>
                      setUserData((prev) => ({
                        ...prev,
                        first_name: e.target.value,
                      }))
                    }
                  />
                  {userData.first_name && (
                    <span
                      className="clear-icon"
                      style={{
                        top: "40px",
                      }}
                      onClick={() =>
                        setUserData((prev) => ({ ...prev, first_name: "" }))
                      }
                    >
                      &times;
                    </span>
                  )}
                </div>{" "}
                <div className="input-wrapper">
                  <label>
                    Last Name<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Last Name"
                    value={userData.last_name}
                    onChange={(e) =>
                      setUserData((prev) => ({
                        ...prev,
                        last_name: e.target.value,
                      }))
                    }
                  />
                  {userData.last_name && (
                    <span
                      className="clear-icon"
                      style={{
                        top: "40px",
                      }}
                      onClick={() =>
                        setUserData((prev) => ({ ...prev, last_name: "" }))
                      }
                    >
                      &times;
                    </span>
                  )}
                </div>
                <div className="input-wrapper">
                  <label>
                    Phone Number
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <PhoneInput
                    country={"us"} // Default country code
                    value={userData.phone_number}
                    onChange={(phone, country) =>
                      setUserData((prev) => ({
                        ...prev,
                        phone_number: phone,
                        country_code: country.dialCode,
                      }))
                    }
                    inputStyle={{
                      width: "250px",

                      marginBottom: "1rem",
                      border: "none",
                      borderRadius: "5px",
                      boxShadow: "none",
                      height: "30px",
                      fontSize: "1rem",
                    }}
                  />
                  {userData.phone_number && (
                    <span
                      className="clear-icon"
                      style={{
                        top: "40px",
                      }}
                      onClick={() =>
                        setUserData((prev) => ({ ...prev, phone_number: "" }))
                      }
                    >
                      &times;
                    </span>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="input-wrapper">
                  <label>
                    Address<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Address"
                    value={userData.address}
                    onClick={(e) => setMapDialogOpen(true)}
                    onChange={(e) => {}}
                  />
                  {userData.address && (
                    <span
                      className="clear-icon"
                      style={{
                        top: "40px",
                      }}
                      onClick={() =>
                        setUserData((prev) => ({ ...prev, address: "" }))
                      }
                    >
                      &times;
                    </span>
                  )}
                </div>

                <div className="input-wrapper">
                  <label>Work Phone Number <span style={{ color: "gray" }}> (Optional)</span></label>
                  <PhoneInput
                    country={"us"} // Default country code
                    value={userData.work_phone_number}
                    onChange={(phone, country) =>
                      setUserData((prev) => ({
                        ...prev,
                        work_phone_number: phone,
                        country_code: !prev.phone_number
                          ? country.dialCode
                          : prev.country_code,
                      }))
                    }
                    inputStyle={{
                      width: "250px",

                      marginBottom: "1rem",
                      border: "none",
                      borderRadius: "5px",
                      boxShadow: "none",
                      height: "30px",
                      fontSize: "1rem",
                    }}
                  />
                  {userData.work_phone_number && (
                    <span
                      className="clear-icon"
                      style={{
                        top: "40px",
                      }}
                      onClick={() =>
                        setUserData((prev) => ({
                          ...prev,
                          work_phone_number: "",
                        }))
                      }
                    >
                      &times;
                    </span>
                  )}
                </div>
                <div className="input-wrapper">
                  <label>
                    Company Title
                    <span style={{ color: "gray" }}> (Optional)</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Company Title"
                    value={userData.company_title}
                    onChange={(e) =>
                      setUserData((prev) => ({
                        ...prev,
                        company_title: e.target.value,
                      }))
                    }
                  />
                  {userData.company_title && (
                    <span
                      className="clear-icon"
                      style={{
                        top: "40px",
                      }}
                      onClick={() =>
                        setUserData((prev) => ({ ...prev, company_title: "" }))
                      }
                    >
                      &times;
                    </span>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="input-wrapper">
                  <label>
                    Job Title<span style={{ color: "gray" }}> (Optional)</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Job Title"
                    value={userData.job_title}
                    onChange={(e) =>
                      setUserData((prev) => ({
                        ...prev,
                        job_title: e.target.value,
                      }))
                    }
                  />
                  {userData.job_title && (
                    <span
                      className="clear-icon"
                      style={{
                        top: "40px",
                      }}
                      onClick={() =>
                        setUserData((prev) => ({ ...prev, job_title: "" }))
                      }
                    >
                      &times;
                    </span>
                  )}
                </div>
                <div className="input-wrapper">
                  <label>
                    Your Gender
                    <span style={{ color: "gray" }}> (Optional)</span>
                  </label>
                  <select
                    type="text"
                    placeholder="Plan"
                    value={userData.gender}
                    onChange={(e) =>
                      setUserData((prev) => ({
                        ...prev,
                        gender: e.target.value,
                      }))
                    }
                    style={{
                      width: "95%",
                      height: "50px",
                    }}
                  >
                    <option value="">None</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="no-binary">Non-Binary</option>
                    <option value="none">Prefer not to answer</option>
                  </select>
                </div>
                <div className="input-wrapper">
                  <label>
                    Your age range
                    <span style={{ color: "gray" }}> (Optional)</span>
                  </label>
                  <select
                    type="text"
                    placeholder="Plan"
                    value={userData.age_range}
                    onChange={(e) =>
                      setUserData((prev) => ({
                        ...prev,
                        age_range: e.target.value,
                      }))
                    }
                    style={{
                      width: "95%",
                      height: "50px",
                    }}
                  >
                    <option value="">None</option>
                    <option value="0-17">0-17</option>
                    <option value="18-24">18-24</option>
                    <option value="25-34">25-34</option>
                    <option value="35-44">35-44</option>
                    <option value="45-54">45-54</option>
                    <option value="55-64">55-64</option>
                    <option value="65+">65+</option>
                  </select>
                </div>
              </div>
              <div className="row">
                <div className="input-wrapper">
                  <label>Marital status <span style={{ color: "gray" }}> (Optional)</span></label>
                  <select
                    type="text"
                    placeholder="Plan"
                    value={userData.marital_status}
                    onChange={(e) =>
                      setUserData((prev) => ({
                        ...prev,
                        marital_status: e.target.value,
                      }))
                    }
                    style={{
                      width: "95%",
                      height: "50px",
                    }}
                  >
                    <option value="">None</option>
                    <option value="single">Single</option>
                    <option value="married">Married</option>
                    <option value="unmarried">Unmarried</option>
                    <option value="widowed">Widowed</option>
                    <option value="None">Prefer not to answer</option>
                  </select>
                </div>
                <div className="input-wrapper">
                  <label>Your annual income range <span style={{ color: "gray" }}> (Optional)</span></label>
                  <select
                    type="text"
                    placeholder="Plan"
                    value={userData.annual_income_range}
                    onChange={(e) =>
                      setUserData((prev) => ({
                        ...prev,
                        annual_income_range: e.target.value,
                      }))
                    }
                    style={{
                      width: "95%",
                      height: "50px",
                    }}
                  >
                    <option value="">None</option>
                    <option value="$9,999 or less">$9,999 or less</option>
                    <option value="$10,000 - $24,999">$10,000 - $24,999</option>
                    <option value="$25,000 - $49,999">$25,000 - $49,999</option>
                    <option value="$50,000 - $74,999">$50,000 - $74,999</option>
                    <option value="$75,000 - $99,999">$75,000 - $99,999</option>
                    <option value="$100,000 or more">$100,000 or more</option>
                    <option value="None">Prefer not to answer</option>
                  </select>
                </div>
                <div className="input-wrapper">
                  <label>Employment status <span style={{ color: "gray" }}> (Optional)</span></label>
                  <select
                    type="text"
                    placeholder="Plan"
                    value={userData.employment_status}
                    onChange={(e) =>
                      setUserData((prev) => ({
                        ...prev,
                        employment_status: e.target.value,
                      }))
                    }
                    style={{
                      width: "95%",
                      height: "50px",
                    }}
                  >
                    <option value="">None</option>
                    <option value="full-time">Full-Time</option>
                    <option value="part-time">Part-Time</option>
                    <option value="self-employed">Self-Employed</option>
                    <option value="unemployed">Unemployed</option>
                    <option value="not-looking-for-job">
                      Not looking for job
                    </option>
                    <option value="homemaker">Homemaker</option>
                    <option value="student">Student</option>
                    <option value="none">Prefer not to answer</option>
                  </select>
                </div>
              </div>
              <div className="row">
                <div className="input-wrapper">
                  <label>Education attainment <span style={{ color: "gray" }}> (Optional)</span></label>
                  <select
                    type="text"
                    placeholder="Plan"
                    value={userData.education_attainment}
                    onChange={(e) =>
                      setUserData((prev) => ({
                        ...prev,
                        education_attainment: e.target.value,
                      }))
                    }
                    style={{
                      width: "95%",
                      height: "50px",
                    }}
                  >
                    <option value="">None</option>
                    <option value="less-than-high-school">
                      Less than high school
                    </option>
                    <option value="high-school-graduate">
                      High school graduate
                    </option>
                    <option value="some-college">Some college</option>
                    <option value="associate-degree">Associate degree</option>
                    <option value="bachelor-degree">Bachelor's degree</option>
                    <option value="graduate-degree">Graduate degree</option>
                    <option value="none">Prefer not to answer</option>
                  </select>
                </div>
                <div className="input-wrapper">
                  <label>Date Of Birth <span style={{ color: "gray" }}> (Optional)</span></label>
                  <input
                    type="date"
                    placeholder="Date Of Birth"
                    value={userData.dob}
                    onChange={(e) =>
                      setUserData((prev) => ({
                        ...prev,
                        dob: e.target.value,
                      }))
                    }
                  />
                </div>
              </div>
            </div>

            {loading ? (
              <button id="loading-screen" className="sign_up_form_button">
                <svg viewBox="0 0 100 100">
                  <path
                    d="M10 50A40 40 0 0 0 90 50A40 44.8 0 0 1 10 50"
                    fill="#ffffff"
                    stroke="none"
                  >
                    <animateTransform
                      attributeName="transform"
                      type="rotate"
                      dur="1s"
                      repeatCount="indefinite"
                      keyTimes="0;1"
                      values="0 50 51;360 50 51"
                    ></animateTransform>
                  </path>
                </svg>
              </button>
            ) : (
              <button onClick={updateUser} className="sign_up_form_button">
                Save
              </button>
            )}
            {error ? <p style={{ color: "red" }}>{error}</p> : ""}
          </div>
        ) : (
          <p className="verifying_email">Verifying Email...</p>
        )}
        {/* Map Dialog */}
        {mapDialogOpen ? (
          <div className="map-dialog">
            <div className="map-dialog-content">
              <LoadScript
                googleMapsApiKey={googleMapsApiKey}
                libraries={["places"]}
              >
                {/* Autocomplete Search Box */}
                <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
                  <input
                    type="text"
                    placeholder="Search location..."
                    style={{
                      boxSizing: `border-box`,
                      border: `1px solid transparent`,
                      width: `300px`,
                      height: `40px`,
                      padding: `0 12px`,
                      borderRadius: `3px`,
                      boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                      fontSize: `16px`,
                      position: "absolute",
                      top: "10px",
                      left: "50%",
                      marginLeft: "-150px",
                      zIndex: "100",
                    }}
                  />
                </Autocomplete>

                {/* Google Map Component */}
                <GoogleMap
                  ref={mapRef}
                  center={{
                    lat: selectedLocation.lat || 37.7749,
                    lng: selectedLocation.lng || -122.4194,
                  }}
                  zoom={10}
                  onClick={(e) => {
                    const lat = e.latLng.lat();
                    const lng = e.latLng.lng();
                    setSelectedLocation({ lat, lng });
                    handleMapClick(lat, lng);
                  }}
                  mapContainerStyle={{ height: "400px", width: "350px" }}
                >
                  {selectedLocation.lat && selectedLocation.lng && (
                    <Marker position={selectedLocation} />
                  )}
                </GoogleMap>
              </LoadScript>

              <button
                onClick={() => setMapDialogOpen(false)}
                style={{ marginTop: "20px" }}
              >
                Close Map
              </button>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      <Footer />
    </>
  );
};

export default VerifyEmail;
